import { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import httpClient from "../../custom-hooks/httpClient";
import LoginImageBanner from "../LoginImgBanner";
import logo from "../../images/kegow-color.png";

function SignUp() {
  const history = useHistory();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => setIsChecked(!isChecked);

  const handleChange = (e) => {
    setPhoneNumber(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    //prevents users from manipulating terms and conditions
    if (!isChecked) {
      toast.error(
        "You must agree to the terms & conditions before continuing."
      );
      return;
    }

    setIsSigningUp(true);
    // Set phone number in local storage
    localStorage.setItem("phoneNumber", `234${phoneNumber.substring(1)}`);
    // Get OTP
    httpClient
      .get(`/auth?phone_number=234${phoneNumber.substring(1)}`)
      .then(({ status }) => {
        setIsSigningUp(false);
        if (status === 200) {
          history.push("/otp");
        }
      })
      .catch((err) => {
        setIsSigningUp(false);
        // console.log(err.response.data);
        toast.error(
          err && err.response ? err.response.data.message : "Error signing up"
        );
      });
  };

  return (
    <>
      <section className="login-page row min-vh-100 d-flex mt-6 mt-md-0 flex-row">
        <LoginImageBanner />

        <div className="d-flex col-12 align-items-center p-7 col-md-6">
          <div className="p-7 container me-md-4">
            <img
              className="keg-login-logo mb-6 mb-md-6"
              src={logo}
              alt="kegow-pic"
            />
            <h1 className="mb-0 fw-medium text-primary">Sign up</h1>
            <p className="mb-6">Start with your phone number</p>
            <form className="mb-6" onSubmit={handleSubmit}>
              <label className="form-label" htmlFor="number">
                Phone number
              </label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">+234</span>
                </div>
                <input
                  type="tel"
                  className="form-control"
                  placeholder="08023456789"
                  onChange={handleChange}
                  pattern="0[0-9]{10}"
                  title="Numbers only, like 08023456789"
                  maxLength="11"
                  id="number"
                  required
                  // value={phoneNumber}
                />
              </div>

              <div className="d-flex mt-6">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                    checked={isChecked}
                    onChange={() => handleCheckboxChange(setIsChecked)}
                    required
                  />
                  <label
                    className="form-check-label pb-3"
                    htmlFor="flexCheckDefault"
                  >
                    <Link
                      to="/terms-and-conditions/account"
                      className="text-decoration-none fw-bold"
                    >
                      Terms and Conditions
                    </Link>
                  </label>
                </div>
              </div>
              {isSigningUp ? (
                <button className="btn w-100 btn-primary">
                  <Loader type="Oval" color="#fff" width={20} height={20} />
                </button>
              ) : (
                <button className="btn w-100 btn-primary" type="submit">
                  Sign up
                </button>
              )}
            </form>
            <p className="mb-0 ">
              Already have an account?{" "}
              <Link className="text-decoration-none fw-bold" to="/login">
                Log in
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default SignUp;
